import { Get, Post, Put } from "../../../common/httpRestServices";
import { apiUrl, moderationApi } from "../../../helper/ApiUrl";
import { encodeGetParams } from "../../../helper/Encypt";
import { MODERATION_ENTITIES } from "./moderationActionTypes";

export const moderationServices = {
  fetchModerationList: async (entityType, organisationId, filters = {}) => {
    const endpoints = {
      [MODERATION_ENTITIES.PENDING_USERS]: `${apiUrl}api/moderation/users/inprogress`,
      [MODERATION_ENTITIES.APPROVED_USERS]: `${apiUrl}api/moderation/users/approved`,
      [MODERATION_ENTITIES.REJECTED_USERS]: `${apiUrl}api/moderation/users/rejected`,
      [MODERATION_ENTITIES.REPORTS]: `/organisations/${organisationId}/reports`,
    };

    const endpoint = endpoints[entityType];
    if (!endpoint) {
      throw new Error(`Unknown entity type: ${entityType}`);
    }
    const response = await Get(`${endpoint}?${encodeGetParams(filters)}`, true);
    return response.data;
  },

  approveUserRequest: async (assignmentData) => {
    const response = await Put(
      `${apiUrl}api/moderation/users/assign`,
       assignmentData,
       true
    );
    return response;
  },

  rejectUserRequest: async (payload) => {
    const response = await Put(
      `${apiUrl}api/moderation/users/assign`,
       payload,
       true
    );
    return response;
  },

  // Employee management
  fetchEmployeesList: async (organisationId, filters = {}) => {
    const response = await Get(`${apiUrl}api/moderation/users/employees?${encodeGetParams(filters)}`, true);
    return response.data;
  },

  assignEmployeeToUser: async (organisationId, userId, employeeId) => {
    const response = await Put(
      `/organisations/${organisationId}/users/${userId}/assign-employee`,
      { employeeId }
    );
    return response.data;
  },

  // Reassign employee
  reassignEmployeeToUser: async (organisationId, userId, newEmployeeId) => {
    const response = await Put(
      `/organisations/${organisationId}/users/${userId}/reassign-employee`,
      { newEmployeeId }
    );
    return response.data;
  },

  updateModerationRow: async (entityType, organisationId, rowId, payload) => {
    const newObj = {
      toUser: rowId,
      type: 'user',
      blockStatus: payload?.isBlock
    };
    const response = Post(
      `${apiUrl}${moderationApi.blockUserGroup}?organisationId=${organisationId}`,
      newObj,
      true
    );
    return response;
  },

  updateUserStatus: async (organisationId, userId, statusData) => {
    return moderationServices.updateModerationRow(
      MODERATION_ENTITIES.APPROVED_USERS,
      organisationId,
      userId,
      statusData
    );
  },

  reassignEmployee: async (organisationId, userId, employeeData) => {
    return moderationServices.updateModerationRow(
      MODERATION_ENTITIES.APPROVED_USERS,
      organisationId,
      userId,
      employeeData,
      { method: 'PATCH' }
    );
  },
};
